export default "__VITE_ASSET__BjvWBSL3__"